module.exports = __webpack_public_path__ + "static/img/02.065bd76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/ldt/02.png
// module id = oFEY
// module chunks = 0